export const PORTAL_POST_LIST_REQUEST = 'PORTAL_POST_LIST_REQUEST';
export const PORTAL_POST_LIST_SUCCESS = 'PORTAL_POST_LIST_SUCCESS';
export const PORTAL_POST_LIST_FAIL = 'PORTAL_POST_LIST_FAIL';

export const PORTAL_POST_LIST_BY_IDS_REQUEST = 'PORTAL_POST_LIST_BY_IDS_REQUEST';
export const PORTAL_POST_LIST_BY_IDS_SUCCESS = 'PORTAL_POST_LIST_BY_IDS_SUCCESS';
export const PORTAL_POST_LIST_BY_IDS_FAIL = 'PORTAL_POST_LIST_BY_IDS_FAIL';

export const PORTAL_POST_DETAILS_REQUEST = 'PORTAL_POST_DETAILS_REQUEST';
export const PORTAL_POST_DETAILS_SUCCESS = 'PORTAL_POST_DETAILS_SUCCESS';
export const PORTAL_POST_DETAILS_FAIL = 'PORTAL_POST_DETAILS_FAIL';
export const PORTAL_POST_DETAILS_RESET = 'PORTAL_POST_DETAILS_RESET';

export const PORTAL_POST_CREATE_REQUEST = 'PORTAL_POST_CREATE_REQUEST';
export const PORTAL_POST_CREATE_SUCCESS = 'PORTAL_POST_CREATE_SUCCESS';
export const PORTAL_POST_CREATE_FAIL = 'PORTAL_POST_CREATE_FAIL';

export const PORTAL_POST_UPDATE_REQUEST = 'PORTAL_POST_UPDATE_REQUEST';
export const PORTAL_POST_UPDATE_SUCCESS = 'PORTAL_POST_UPDATE_SUCCESS';
export const PORTAL_POST_UPDATE_FAIL = 'PORTAL_POST_UPDATE_FAIL';

export const PORTAL_POST_DELETE_REQUEST = 'PORTAL_POST_DELETE_REQUEST';
export const PORTAL_POST_DELETE_SUCCESS = 'PORTAL_POST_DELETE_SUCCESS';
export const PORTAL_POST_DELETE_FAIL = 'PORTAL_POST_DELETE_FAIL';

export const PORTAL_POST_DTO_REQUEST = 'PORTAL_POST_DTO_REQUEST';
export const PORTAL_POST_DTO_SUCCESS = 'PORTAL_POST_DTO_SUCCESS';
export const PORTAL_POST_DTO_FAIL = 'PORTAL_POST_DTO_FAIL';
